import $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';

$(document).on('dblclick', '.VueTables__table tbody > tr', function() {
  $(this).find('.btn.view').click();
  document.getSelection().removeAllRanges();
});


/**
 * @todo This should be changed to a event-based solution
 * Vue tables 2 doesn't seem to offer a way to detect 
 * table inits globally
 */
$(document).ready(function() {
  let scrollbars = [];

  let scrollbarSelectors = [
    '.table-responsive:not(.ps)',
    '.modal-body:not(.ps)'
  ].join(',');

  setInterval(function() {
    $(scrollbarSelectors).each(function() {
      scrollbars.push(new PerfectScrollbar($(this)[0]));
    });

    scrollbars.forEach((scrollbar) => {
      scrollbar.update();
    });
  }, 1000);

  $(window).resize(
    _.throttle(() => {
      scrollbars.forEach((scrollbar) => {
        scrollbar.update();
      });
    }, 1000)
  );
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/Table.js